export const CARE_STATE_OVERVIEW_TAB_ID = 'careState:overview';
export const CARE_STATE_SCOPED_TAB_ID = 'careState:scoped';

export { CareStateNoteTab } from './ui/CareStateNoteTab';
export type { CareStateNoteTabProps } from './ui/CareStateNoteTab';
